// extracted by mini-css-extract-plugin
module.exports = {"voucherDetails":"voucherInfo_voucherDetails__19c3f","voucherValue":"voucherInfo_voucherValue__-3WMC"};